let mapContainerSelector;

const initMap = (containerSelector, timeout = 2000) => {
    mapContainerSelector = containerSelector;
    //console.log('initMap timout', timeout)
    return new Promise(function(resolve, reject) {
        setTimeout(() => {
            let elem = document.createElement('script');
            elem.type = 'text/javascript';
            //elem.src = '//api-maps.yandex.ru/2.0/?load=package.standard&lang=ru-RU&onload=renderMap';
            elem.src = '//api-maps.yandex.ru/2.1/?lang=ru_RU?load=package.standard&lang=ru-RU';
            document.getElementsByTagName('body')[0].appendChild(elem);

            // дожидаемся загрузки скрипта
            elem.onload = () => {
                // дожидаемся инициализации библиотеки карты
                ymaps.ready(() => {
                    resolve(renderMap());
                })
            }
            elem.onerror = (e) => {
                reject(e);
            }
        }, timeout);
    });
}

const renderMap = () => {
    //console.log('start render map in "' + mapContainerSelector + '" container element');
    document.getElementById(mapContainerSelector).innerHTML = '';
    let center = [59.91807199347784,30.304908500000003];
    if (typeof App !== 'undefined' && typeof App.map !== 'undefined' && typeof App.map.center !== 'undefined') {
        center = App.map.center;
    }
    const map = new ymaps.Map(mapContainerSelector, {
        center: center,
        zoom: 12,
        behaviors: ['default'],
        controls: ['zoomControl', 'typeSelector'],
    });

    map.behaviors.disable(['scrollZoom']);
    map.options.set({
        'minZoom': 8,
        'maxZoom': 17
    });

    ymaps.geocode("Санкт-Петербург, ул. Невский проспект, 28").then(function (res) {
        let coord = res.geoObjects.get(0).geometry.getCoordinates();
        let myPlacemark = new ymaps.Placemark(coord);
        map.geoObjects.add(myPlacemark);
        map.setCenter(coord);
    });

    return map;
}

const createClinicPLacemark = (clinic) => {
    //console.log(clinic);
    return new ymaps.Placemark([clinic.coords.lng, clinic.coords.lat], {
        balloonContent: clinic.balloonContent,
        hintContent: clinic.name,
        clinicId: clinic.id,
        iconColor: clinic.color,
        coords: clinic.coords
    }, {
        iconColor: clinic.color,
        //hideIconOnBalloonOpen: !site.isMobile(),
    });
}

export {initMap, createClinicPLacemark}